<template>
  <a-modal
      :visible="visible"
      title="导入或导出"
      @cancel="handleCancelParent"
      :footer="null"
      width="400px"
    >
    <div class="modal-body">
      <a-button class="btn-main" type="primary" @click="handleImportExcel">导入Excel数据</a-button>
      <a-button class="btn-main" type="primary" @click="handleImportOmap">导入奥维地图数据</a-button>
      <a-button
        class="btn-main"
        type="primary"
        :loading="exportLoading"
        @click="handleExportExcel"
      >导出到Excel表格</a-button>
    </div>

    <import-excel-modal
      :visible.sync="importExcelModalVisible"
      :markerSetId="markerSetId"
      >
    </import-excel-modal>
    <import-omap-modal
      :visible.sync="importOmapModalVisible"
      :markerSetId="markerSetId"
      >
    </import-omap-modal>
  </a-modal>
</template>

<script>
import ImportExcelModal from './import-excel-modal/index.vue';
import ImportOmapModal from './import-omap-modal/index.vue';

export default {
  components: {
    ImportExcelModal,
    ImportOmapModal,
  },
  props: {
    visible: Boolean,
    markerSetId: String,
  },
  data() {
    return {
      importExcelModalVisible: false,
      importOmapModalVisible: false,
      exportLoading: false,
    };
  },
  methods: {
    handleCancelParent() {
      this.$emit('update:visible', false);
    },
    handleImportExcel() {
      this.importExcelModalVisible = true;
    },
    handleImportOmap() {
      this.importOmapModalVisible = true;
    },
    async handleExportExcel() {
      try {
        this.exportLoading = true;
        const res = await this.$api.importAndExport.exportToExcel({
          markerSetId: this.markerSetId,
          longUuid: localStorage.getItem('longUuid'),
        });
        // 从响应头获取文件名，如果没有则使用默认名
        const contentDisposition = res.headers['content-disposition'];
        let fileName = '导出数据.xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)/i);
          if (match) {
            fileName = decodeURIComponent(match[1].replace(/"/g, ''));
          }
        }
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      } catch (error) {
        console.error(error);
        // blob 响应需要手动解析错误信息
        if (error && error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const errData = JSON.parse(text);
            this.$message.error(errData.msg || '导出失败');
          } catch (e) {
            this.$message.error('导出失败');
          }
        } else {
          const errMsg = (error && error.response && error.response.data
            && error.response.data.message)
            || (error && error.message)
            || '导出失败';
          this.$message.error(errMsg);
        }
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.btn-main {
  width: 100%;
  margin: 10px 0;
}
</style>
